import type { ToastProps } from "@/ui";

/**
 * Default props for the app shell `<Toast />` from `@/ui`.
 * Uses {@link ToastProps} so `position` / `theme` stay aligned with the DS wrapper (no direct `react-toastify` import here — ESLint `no-restricted-imports` in `src/config`).
 */
export const containerSettings: ToastProps = {
    position: "bottom-center" as const,
    autoClose: 5000,
    closeButton: false,
    hideProgressBar: true,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: "colored" as const,
    style: {
        // Above DS modal (1100) / panel (1101); see --ds-z-toast in tokens.
        zIndex: "var(--ds-z-toast)",
    },
};

export const toastSettings = {
    className: "rounded",
};
